export enum HeaderTable{
  titleForUserRoleTable = 'Role',  
}

export enum HeaderColumns {
  roleName = 'Naziv',  
}

export enum ModalForAddOrUpdateUserRole {
  titleForAddRole = 'Dodavanje nove role',
  titleForUpdateRole = 'Izmena naziva role',
  roleNameEmpty = 'Potrebno je uneti naziv role.',
  roleNamePlaceholder = 'Naziv',
  saveSuccessMessage = 'Nova rola je uspešno sačuvana.',
  updateSuccessMessage = 'Naziv role je uspešno izmenjen.',
  deleteSuccessMessage = 'Izabrana rola je uspešno obrisana.',
}
